import { getObjectDifference } from './utils';

export const areIdArraysEqual = (left: number[] = [], right: number[] = []): boolean => {
  if (left.length !== right.length) return false;

  const sortedLeft = [...left].sort((a, b) => a - b);
  const sortedRight = [...right].sort((a, b) => a - b);

  return sortedLeft.every((value, index) => value === sortedRight[index]);
};

/**
 * getObjectDifference is optimized for nested contact objects ({ id, destroy }).
 * Numeric relation arrays (venue_ids, organization_ids) must be diffed separately
 * so adds/removes send the full replacement list to the API.
 */
export const getFormUpdateWithIdArrays = <T extends Record<string, unknown>>(
  baseline: T,
  submission: T,
  idArrayKeys: Array<keyof T>
): Partial<T> => {
  const baselineForDiff = { ...baseline };
  const submissionForDiff = { ...submission };

  idArrayKeys.forEach((key) => {
    delete baselineForDiff[key];
    delete submissionForDiff[key];
  });

  const update = getObjectDifference(baselineForDiff, submissionForDiff) as Partial<T>;

  idArrayKeys.forEach((key) => {
    const baselineIds = (baseline[key] as number[] | undefined) ?? [];
    const submissionIds = (submission[key] as number[] | undefined) ?? [];

    if (!areIdArraysEqual(baselineIds, submissionIds)) {
      update[key] = submissionIds as T[keyof T];
    }
  });

  return update;
};
